import React, { useEffect, useState } from 'react';
import { DeviceDetector } from '../../utils/helper/browserDetection';
import { IEPlaceholder, Placeholder, Wrapper } from './styles.Main';
import { useGlobal } from '../../logic/main';
import { SzeneWrapper } from '../../components/custom/3D/SzeneWrapper';
import { Szene } from '../../components/custom/3D/Szene';
import { Background } from '../../components/custom/3D/Background';
import { AnimatedLines } from '../../components/custom/3D/AnimatedLines';
import { SCROLLY_MAIN_WRAPPER } from '../../components/custom/scrollyteller/ScrollyTeller';
import { Note } from '../../styles/styledComponents';
import { mainConfig } from '../../config/config.provider';
import { isEnglish } from '../../utils/helper/helpers';

export const Main3DSzene: React.FC = () => {
    const [{ navbarHeight, loadingProgress }] = useGlobal(state => ({
        navbarHeight: state.navbarHeight,
        loadingProgress: state.loadingProgress
    }));
    const [showPlaceholder, setShowPlaceholder] = useState(true);

    let loadingProgressRef = React.useRef(loadingProgress);
    let hasEventListener = React.useRef(false);
    let showText = React.useRef(true);

    const handleScroll = () => {
        const initialScrolly = document.getElementsByClassName(SCROLLY_MAIN_WRAPPER)[0];
        if (window.scrollY > window.innerHeight / 4 && loadingProgressRef.current > 99) {
            setShowPlaceholder(false);
        } else {
            setShowPlaceholder(true);
        }

        if (initialScrolly.getBoundingClientRect().top < 20 && loadingProgressRef.current < 99) {
            document.body.style.overflowY = 'hidden';
        } else {
            document.body.style.overflowY = 'scroll';
        }
    };

    useEffect(() => {
        loadingProgressRef.current = loadingProgress;
        if (!hasEventListener.current) {
            document.addEventListener('scroll', handleScroll as any);
        }
        if (loadingProgressRef.current > 99) {
            handleScroll();
            setTimeout(() => {
                showText.current = false;
            }, 500);
        }

        return () => {
            document.removeEventListener('scroll', handleScroll as any);
            hasEventListener.current = false;
        };
    }, [loadingProgress]);

    const getText = () =>
        showText.current
            ? `${
                  isEnglish() ? 'Initialising Graphics (Please wait)' : 'Lade Grafik (Bitte Warten)'
              }: ${loadingProgress.toFixed(0)}%`
            : null;

    return (
        <>
            <Wrapper useFullHeight={false} navbarHeight={navbarHeight}>
                {!DeviceDetector.isInternetExplorer ? (
                    <SzeneWrapper>
                        <Background />
                        <Szene />
                        <AnimatedLines />
                    </SzeneWrapper>
                ) : (
                    <IEPlaceholder />
                )}
                <Note style={{ color: '#757575', position: 'absolute', right: '1rem', bottom: '4rem' }}>
                    {mainConfig.interactiveNote}
                </Note>
            </Wrapper>

            <Placeholder show={showPlaceholder}>{getText()}</Placeholder>
        </>
    );
};
